export default "__VITE_ASSET__fca0de6c__"